function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, dropMenuOpen, keydownProxyEl, searchFilter, view) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'actions-popover-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
          "attrs": {
            open: $attr(`open`) && dropMenuOpen,
            'prevent-close-selectors': JSON.stringify([`mp-create-entity-modal`, ...$attr(`prevent-close-selectors`)])
          },
          "on": {
            change: $helpers.handleDropMenuChange,
            click: ev => ev.stopPropagation(),
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((((view) == (`create-cohort`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-create-entity-modal", {
                "attrs": $helpers.getCohortModalAttributes(),
                "on": {
                  save: $helpers.handleCohortSaved,
                  cancel: $helpers.handleCohortCanceled,
                  modalClosed: $helpers.handleModalClose,
                },
                "props": {
                  existingEntityNames: $attr(`cohort-names`),
                },
              }));;
              return __jade_nodes
            }).call(this)) :
            (((view) == (`breakdown`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'context-menu-search-wrapper': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                  "attrs": {
                    icon: `search`,
                    placeholder: `Search`,
                    value: searchFilter,
                  },
                  "on": {
                    input: $helpers.handleSearchInput
                  },
                  "hook": {
                    insert: $helpers.addKeydownProxyEl
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-properties-menu", {
                "attrs": {
                  'disabled-items': JSON.stringify($helpers.breakdownDisabledItemsMap()),
                  'event-names': JSON.stringify([$attr(`event`)]),
                  open: $attr(`open`),
                  'project-id': $attr(`project-id`),
                  'workspace-id': $attr(`workspace-id`),
                  'search-filter': searchFilter,
                },
                "on": {
                  select: $helpers.handleBreakdownMenuSelect,
                },
                "props": {
                  keydownProxyEl: keydownProxyEl,
                },
              }));;
              return __jade_nodes
            }).call(this)) :
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-popover-card", {
                "attrs": {
                  'button-options': JSON.stringify($attr(`button-options`)),
                  title: $attr(`title`),
                  subtitle: $attr(`subtitle`),
                  'is-segmented': $attr(`is-segmented`)
                },
                "on": {
                  action: $helpers.handlePopoverAction,
                  close: $helpers.handlePopoverClose,
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("slot"));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "dropMenuOpen" in locals ? locals.dropMenuOpen : typeof dropMenuOpen !== "undefined" ? dropMenuOpen : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "view" in locals ? locals.view : typeof view !== "undefined" ? view : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;